import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  active: false,
  snappingValue: 15,
}

const curatorSnappingSlicer = createSlice({
  name: "curatorSnapping",
  initialState,
  reducers: {
    setSnappingActive: (state, { payload }) => {
      state.active = payload;
    },
    setSnappingValue: (state, { payload }) => {
      state.snappingValue = payload;
    }
  },
});

export const {
  setSnappingActive,
  setSnappingValue,
} = curatorSnappingSlicer.actions;

export const curatorSnappingActions = curatorSnappingSlicer.actions;

export const curatorSnappingReducer = curatorSnappingSlicer.reducer;

export const selectRotationSnappingActive = (state) => state.curatorSnapping.active;
export const selectRotationSnappingValue = (state) => state.curatorSnapping.snappingValue;
